import { render } from "./AndroidCard.vue?vue&type=template&id=0e64c766&scoped=true"
import script from "./AndroidCard.vue?vue&type=script&lang=js"
export * from "./AndroidCard.vue?vue&type=script&lang=js"

import "./AndroidCard.vue?vue&type=style&index=0&id=0e64c766&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e64c766"]])

export default __exports__